import $ from 'jquery';
import registerJQueryPlugin from 'styleguide/lib/register-jquery-plugin';
import mergeOptions from 'styleguide/lib/merge-options';

export const PLUGIN_NAME = 'notifyMe';
const DEFAULTS = {};

const validateEmail = (email) => {
    const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
};

const setEventListeners = ($el, opts) => {
    $el.on('click', function() {
        const $emailInput = $('#js-bis-email');
        const $phoneInput = $('#js-modal-bis-phone');
        const $bisContainer = $('.js-bis-input-container');
        const $duplicateInquiry = $('.js-duplicate-inquiry');
        $bisContainer.removeClass('is-error');
        if (!$duplicateInquiry.hasClass('u-hide')) {
            $duplicateInquiry.addClass('u-hide');
        }
        if (!validateEmail($emailInput.val())) {
            $bisContainer.addClass('is-error');
            $emailInput.focus();
            setTimeout(function(){
                $el.progressiveButton('reset');
            }, 400);
            return;
        }

        const data = $.param({
            size : $el.data('size'),
            email : $emailInput.val(),
            phone : $phoneInput.val(),
            code : $el.data('code'),
            allowDuplicate : false
        });

        $.post('/r/ajax/SubmitFindSizeInquiry.jsp', data, function(msg) {
            const result = $.parseJSON(msg);
            if (result.success) {
                $('.js-thank-you-email').html($emailInput.val());
                $bisContainer.addClass('u-hide');
                $('.js-thank-you-container').removeClass('u-hide');
            } else {
                if (result.duplicate) {
                    $duplicateInquiry.removeClass('u-hide');
                }
            }
            $el.progressiveButton('reset');
        });

        logEngagementWithDetails(window.location.href, 'oos similar recs', 'submit notify me', $el.data('code'));
    });
}

export default function notifyMe(el, options) {
    const $el = $(el);
    const opts = mergeOptions(DEFAULTS, options, $el);
    setEventListeners($el, opts);
    $('#js-modal-bis-phone').mask('(000) 000-0000');
}

registerJQueryPlugin(PLUGIN_NAME, notifyMe);


// WEBPACK FOOTER //
// ./src/scripts/entry-points/pdp/notify-me.js